import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _credit_report_list: [], // 체납 조회한 목록.
  _no_credit_report_list: [], // 체납 조회 아직 안 한 리포트 목록.
  _credit_report_status: null,
};

export const mutations = {
  setCreditReportStatus(state, payload) {
    // window.console.log("setCreditReportStatus, payload", payload);
    state._credit_report_status = payload;
  },
  setCreditReportList(state, payload) {
    state._credit_report_list = payload;
  },
  setNoCreditReportList(state, payload) {
    state._no_credit_report_list = payload;
  },
};

export const actions = {
  async acListIndividualCreditReport({ commit }) {
    const url = `/api/v1/credit/indiv/list`;
    try {
      const result = await api.post(url, {});
      if (result?.data?.code === 0) {
        commit("setCreditReportList", result.data.data);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async acListReportsWithoutIndividualCreditReport({ commit }) {
    const url = `/api/v1/credit/indiv/list/reports`;
    try {
      const result = await api.post(url, {});
      if (result?.data?.code === 0) {
        commit("setNoCreditReportList", result.data.data);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async acInitIndividualCreditReport(
    { commit },
    { encoded_report_seq, user_verify_seq, request_type }
  ) {
    const url = `/api/v1/credit/indiv/init`;
    try {
      const result = await api.post(url, {
        encoded_report_seq,
        user_verify_seq,
        request_type,
      });
      if (result?.data?.code === 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async acInitIndividualCreditReportGuest(
    { commit },
    { guest_user_no, encoded_owner_agreement_seq, user_verify_seq, request_type }
  ) {
    const url = `/api/v1/credit/indiv-guest/init`;
    try {
      const result = await api.post(url, {
        guest_user_no,
        encoded_owner_agreement_seq,
        user_verify_seq,
        request_type,
      });
      if (result?.data?.code === 0 && result?.data?.data) {
        return result?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  async acOwnerConnectIndividualCredit(
    { commit },
    { encoded_owner_agreement_seq, user_verify_seq }
  ) {
    const url = `/api/v1/credit/indiv/owner/connect`;
    try {
      const result = await api.post(url, {
        encoded_owner_agreement_seq,
        user_verify_seq,
      });
      if (result?.data?.code === 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async acGetIndividualCreditReportStatus({ commit }, { encoded_report_seq }) {
    const url = `/api/v1/credit/indiv/status`;
    try {
      const result = await api.get(`${url}?report_seq=${encoded_report_seq}`);
      if (result?.data?.code === 0) {
        commit("setCreditReportStatus", result.data.data);
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        commit("setCreditReportStatus", null);
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      commit("setCreditReportStatus", null);
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acGetIndividualCreditReportStatusForRealtor(
    { commit },
    { encoded_realtor_request_seq }
  ) {
    const url = `/api/v1/credit/indiv/realtor/status`;
    try {
      const result = await api.get(
        `${url}?realtor_request_seq=${encoded_realtor_request_seq}`
      );
      if (result?.data?.code === 0) {
        commit("setCreditReportStatus", result.data.data);
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        commit("setCreditReportStatus", null);
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      commit("setCreditReportStatus", null);
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acGetIndividualCreditReportForTenant(
    { commit },
    { encoded_credit_info_report_seq }
  ) {
    const url = `/api/v1/credit/indiv/query/tenant`;
    try {
      const result = await api.post(url, {
        credit_info_report_seq: encoded_credit_info_report_seq,
      });
      if (result?.data?.code === 0) {
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acGetIndividualCreditReportForOwner(
    { commit },
    { encoded_credit_owner_agreement_seq }
  ) {
    const url = `/api/v1/credit/indiv/query/owner`;
    try {
      const result = await api.post(url, {
        credit_owner_agreement_seq: encoded_credit_owner_agreement_seq,
      });
      if (result?.data?.code === 0) {
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acGetIndividualCreditReportForOwnerTenant(
    { commit },
    { encoded_credit_owner_agreement_seq }
  ) {
    const url = `/api/v1/credit/indiv/query/per-owner`;
    try {
      const result = await api.post(url, {
        credit_owner_agreement_seq: encoded_credit_owner_agreement_seq,
      });
      if (result?.data?.code === 0) {
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acGetIndividualCreditReportForGuest(
    { commit },
    { user_no, credit_info_report_seq, owner_agreement_seq  }
  ) {
    const url = `/api/v1/credit/indiv-guest/query`;
    try {
      const result = await api.post(url, {
        user_no: user_no,
        credit_info_report_seq: credit_info_report_seq,
        owner_agreement_seq: owner_agreement_seq,
      });
      if (result?.data?.code === 0) {
        return {
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          success: false,
          data: null,
          message: result?.data?.message,
        };
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error?.message,
      };
    }
  },
  async acSendIndividualCreditAgreementRequestToRealtor(
    { commit },
    { encoded_credit_info_report_seq, realtor_phone_number }
  ) {
    const url = `/api/v1/credit/indiv/request/to-realtor`;
    try {
      const result = await api.post(url, {
        encoded_credit_info_report_seq: encoded_credit_info_report_seq,
        realtor_phone_number: realtor_phone_number,
      });
      if (result?.data?.code === 0) {
        return {
          code: result.data.code,
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          code: result.data.code,
          success: false,
          data: null,
          message: result?.message,
        };
      }
    } catch (error) {
      // window.console.log("error: ", error);
      const errorData = error?.response?.data;
      return {
        code: errorData?.code,
        success: false,
        data: null,
        message: errorData?.message,
      };
    }
  },
  async acSendIndividualCreditAgreementRequestTenantToOwners(
    { commit },
    { owner_requests }
  ) {
    const url = `/api/v1/credit/indiv/request/tenant-to-owners`;
    try {
      const result = await api.post(url, {
        owner_requests: owner_requests,
        /**
         * owner_requests: {
         *   encoded_owner_agreement_seq: string;
         *   owner_mobile: string; // 유저가 입력한 소유자 전화번호.
         * }[]
         */
      });
      if (result?.data?.code === 0) {
        return {
          code: result.data.code,
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          code: result.data.code,
          success: false,
          data: null,
          message: result?.message,
        };
      }
    } catch (error) {
      // window.console.log("error: ", error);
      const errorData = error?.response?.data;
      return {
        code: errorData?.code,
        success: false,
        data: null,
        message: errorData?.message,
      };
    }
  },
  async acSendIndividualCreditAgreementRequestRealtorToOwners(
    { commit },
    { encoded_realtor_request_seq, owner_requests }
  ) {
    const url = `/api/v1/credit/indiv/realtor/request/realtor-to-owners`;
    try {
      const result = await api.post(url, {
        encoded_realtor_request_seq: encoded_realtor_request_seq,
        owner_requests: owner_requests,
        /**
         * owner_requests: {
         *   encoded_owner_agreement_seq: string;
         *   owner_mobile: string; // 유저가 입력한 소유자 전화번호.
         * }[]
         */
      });
      if (result?.data?.code === 0) {
        return {
          code: result.data.code,
          success: true,
          data: result.data.data,
          message: result.data.message,
        };
      } else {
        return {
          code: result.data.code,
          success: false,
          data: null,
          message: result?.message,
        };
      }
    } catch (error) {
      // window.console.log("error: ", error);
      const errorData = error?.response?.data;
      return {
        code: errorData?.code,
        success: false,
        data: null,
        message: errorData?.message,
      };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
